export const OPERATION_STEPS_TYPES = {
  AUTOMATIC_CONFERENCE: 'Conferência Automática',
  AUTOMATIC_CONFERENCE_SALARY_INCREASE: 'Conferência automática aumento salarial',
  AUTOMATIC_CONFERENCE_USED_OVER_35_PERCENT: 'AUTOMATIC_CONFERENCE_USED_OVER_35_PERCENT',
  AUTOMATIC_PORT_CONFERENCE: 'Conferência automática - Portabilidade',
  AUTO_TYPING_ERROR: 'Erro na digitação automática',
  BANK_ANALYSIS: 'Análise Banco',
  BPC_LOAS_ENDORSEMENT_PENDING: 'BPC_LOAS_ENDORSEMENT_PENDING',
  CANCELED_BY_CLIENT: 'Cancelado pelo cliente',
  CANCELED_MANUALLY: 'CANCELED_MANUALLY',
  CANCELED_MARGIN_INCREASE: 'Cancelado aumento de margem',
  CANCELLED_BY_STATEMENT_CLOSURE: 'Cancelado - Fechamento de fatura',
  CANCEL_REQUESTED_BY_CLIENT: 'Solicitação de cancelamento pelo cliente',
  CLIENT_INELIGIBLE_FOR_LOAN: 'Cliente inelegível para empréstimos',
  COMPANY_DATA_NOT_FOUND_ERROR: 'Erro - Dados da Empresa',
  COMPLIANCE: 'Análise de Compliance',
  COMPLIANCE_APPROVED: 'Compliance Aprovado',
  CONFERENCE: 'Conferência',
  CONFERENCE_ADDITIONAL_WORKCODE_VALIDATION: 'Conferência Adicional do Código de Trabalho',
  CONFERENCE_MAGNETIC_CARD: 'CONFERENCE_MAGNETIC_CARD',
  CONFERENCE_ON_HOLD: 'Conferência em espera',
  CONFERENCE_PENDENCY: 'Conferência de Pendência Resolvida',
  CONTRACT_SETTLEMENT_REQUIRED: 'Solicitação de liquidação de pagamento pelo cliente',
  CREATING_CCB: 'CREATING_CCB',
  CREDIT_POLICY_REVIEW: 'Aguardando Revisão - Política Interna',
  DISAPPROVED: 'Reprovado (não utilizar)',
  ENDORSED: 'Averbado',
  ENDORSEMENT: 'Averbação',
  ENDORSEMENT_PENDING: 'Averbação Pendente',
  ENDORSEMENT_PENDING_LOCKED_BENEFIT: 'Averbação pendente por benefício bloqueado',
  ENDORSEMENT_PENDING_RATE_REVIEW: 'Averbação Pendente - Revisão de Taxa',
  ENDORSEMENT_PENDING_TECHNOLOGY_REVIEW: 'Pendência Averbação - Revisão da Tecnologia',
  ERROR_PIX_DENIED: 'Erro Pix Negado',
  ERROR_PIX_DENIED_SECURITY: 'Erro Pix Negado Segurança',
  EXCEEDED_MARGIN: 'EXCEEDED_MARGIN',
  EXCEEDED_MARGIN_ANALISYS: 'Análise Margem Excedida',
  FGTS_CONFERENCE_ON_HOLD: 'FGTS - Conferência em espera',
  FGTS_MINIMAL_CONFERENCE: 'FGTS - Conferência mínima',
  FGTS_NEW_AUTOMATIC_CONFERENCE: 'FGTS - Conferência automática',
  FGTS_NEW_AUTO_TYPING_ERROR: 'FGTS - Erro na digitação automática',
  FGTS_NEW_BANK_ANALYSIS: 'FGTS - Análise Banco',
  FGTS_NEW_CANCELED_BY_CLIENT: 'FGTS - Cancelado pelo cliente',
  FGTS_NEW_CANCELED_MARGIN_INCREASE: 'FGTS - Cancelado aumento de margem',
  FGTS_NEW_CANCEL_REQUESTED_BY_CLIENT: 'FGTS - Cancelamento solicitado pelo cliente',
  FGTS_NEW_CLIENT_INELIGIBLE_FOR_LOAN: 'FGTS - Cliente inelegível para empréstimos',
  FGTS_NEW_COMPLIANCE: 'FGTS - Análise de Compliance',
  FGTS_NEW_COMPLIANCE_APPROVED: 'FGTS - Compliance Aprovado',
  FGTS_NEW_CONFERENCE: 'FGTS - Conferência',
  FGTS_NEW_CONFERENCE_ADDITIONAL_WORKCODE_VALIDATION: 'FGTS - Conferência - Perícia',
  FGTS_NEW_CONFERENCE_PENDENCY: 'FGTS - Conferência da pendência resolvida',
  FGTS_NEW_CONTRACT_SETTLEMENT_REQUIRED: 'FGTS - Solicitação de liquidação do contrato pelo cliente',
  FGTS_NEW_CREATING_CCB: 'FGTS - Enviando CCB para QITECH',
  FGTS_NEW_DISAPPROVED: 'FGTS - Reprovado (não utilizar)',
  FGTS_NEW_ENDORSED: 'FGTS - Averbado',
  FGTS_NEW_ENDORSEMENT: 'FGTS - Averbação',
  FGTS_NEW_ENDORSEMENT_PENDING: 'FGTS - Pendência Averbação',
  FGTS_NEW_ENDORSEMENT_PENDING_TECHNOLOGY_REVIEW: 'FGTS - Pendência Averbação',
  FGTS_NEW_EXCEEDED_MARGIN_ANALISYS: 'FGTS - Análise Margem Excedida',
  FGTS_NEW_FORMALIZATION: 'FGTS - Pendência Formalização',
  FGTS_NEW_PAID: 'FGTS - Pago',
  FGTS_NEW_PAYMENT_ERROR: 'FGTS - Erro no Pagamento',
  FGTS_NEW_PAYMENT_RESUBMITTED: 'FGTS - Pagamento reapresentado',
  FGTS_NEW_PAYMENT_RETURNED: 'FGTS - Pagamento devolvido',
  FGTS_NEW_PAYMENT_RETURNING_BY_CLIENT: 'FGTS - Pagamento em devoluçao pelo cliente',
  FGTS_NEW_PENDENCY_BANK: 'FGTS - Pendência Banco',
  FGTS_NEW_PENDENCY_MEU_TUDO: 'FGTS - Pendência Meu TUDO',
  FGTS_NEW_PENDING_AUTHORIZATION_SIGAC: 'FGTS - Pendência Autorização Sigac',
  FGTS_NEW_PENDING_AUTORIZATION: 'FGTS - Pendência Autorização',
  FGTS_NEW_PENDING_CONSENT_SIGAC: 'FGTS - Pendência Anuência Sigac',
  FGTS_NEW_POSSIBILITY_FRAUD: 'FGTS - Conferência automática',
  FGTS_NEW_PRODUCT_SECURITY: 'FGTS - Segurança do Produto',
  FGTS_NEW_PRODUCT_SECURITY_ON_HOLD: 'FGTS - Segurança do produto em espera',
  FGTS_NEW_REFUSED_BANK_ANALISYS: 'FGTS - Reprovado Análise Banco',
  FGTS_NEW_REFUSED_CLIENT_PENDING_DOCUMENT: 'FGTS - Reprovado Pendente Cliente (Documentação)',
  FGTS_NEW_REFUSED_CLIENT_PENDING_FORMALIZATION: 'FGTS - Reprovado Pendente Cliente (Formalização)',
  FGTS_NEW_REFUSED_CONTRACT: 'FGTS - Reprovado 2 (não utilizar)',
  FGTS_NEW_REFUSED_DOCUMENT_WITH_RESTRICTION: 'FGTS - Reprovado CPF com Restrição',
  FGTS_NEW_REFUSED_ENDORSEMENT_FAIL: 'FGTS - Reprovado Averbação Falhou',
  FGTS_NEW_REFUSED_ENDORSEMENT_PENDING: 'FGTS - Reprovado Averbação Pendente',
  FGTS_NEW_REFUSED_EXCEEDED_MARGIN: 'FGTS - Reprovado Margem Excedida',
  FGTS_NEW_REFUSED_FRAUD: 'FGTS - Reprovado Fraude',
  FGTS_NEW_REFUSED_INPROGRESS_PORTABILITY: 'FGTS - Reprovado Port em andamento',
  FGTS_NEW_REFUSED_INTERNAL_POLICY: 'FGTS - Reprovado Política Interna',
  FGTS_NEW_REFUSED_MAX_RISK: 'FGTS - Reprovado Risco Máximo Atingido',
  FGTS_NEW_REFUSED_NOT_LITERATE: 'FGTS - Reprovado Não Alfabetizado',
  FGTS_NEW_REFUSED_UNABLE_UNLOCK_BENEFIT: 'FGTS - Reprovado Desbloqueio não Disponível',
  FGTS_NEW_REFUSED_VISUALLY_IMPAIRED: 'FGTS - Reprovado Deficiente Visual',
  FGTS_NEW_TYPING: 'FGTS - Digitação',
  FGTS_NEW_UNDEFINED: 'FGTS - Não definido',
  FGTS_NEW_UNDONE_ENDORSEMENT: 'FGTS - Desaverbado',
  FGTS_NEW_UNDO_ENDORSEMENT: 'FGTS - Desaverbação',
  FGTS_NEW_USED_35_PERCENT_ENDORSEMENT: 'FGTS - Averbação margem 35%',
  FGTS_NEW_USED_OVER_35_PERCENT: 'FGTS - 35 por cento da margem',
  FGTS_NEW_USED_OVER_35_PERCENT_CONFERED: 'FGTS - 35 por cento da margem conferido',
  FGTS_NEW_VALIDATED_PRODUCT_SECURITY: 'FGTS - Validado Segurança do Produto',
  FGTS_NEW_WAITING_UNLOCK_BENEFIT_DATE: 'FGTS - Aguardando data de desbloqueio',
  FGTS_OPERATION_CANCEL: 'FGTS - Aguardando confirmação da averbação',
  FGTS_REFUSED_AUTOMATIC: 'FGTS - Reprovado Fraude Automaticamente',
  FORMALIZATION: 'Pendência Formalização',
  FUTURE_MARGIN_CONFERENCE_ON_HOLD: 'Conferência em espera',
  FUTURE_MARGIN_PRODUCT_SECURITY_ON_HOLD: 'Segurança do produto em espera',
  INVALID_HASH: 'Hash inválida',
  MINIMAL_CONFERENCE: 'Conferência mínima',
  PAB_AUTOMATIC_CONFERENCE: 'PAB_AUTOMATIC_CONFERENCE',
  PAB_ELEGIBILITY: 'PAB_ELEGIBILITY',
  PAID: 'Pago',
  PAYMENT_ERROR: 'Erro no Pagamento',
  PAYMENT_RESUBMITTED: 'Pagamento Reapresentado',
  PAYMENT_RETURNED: 'Pagamento Devolvido',
  PAYMENT_RETURNING_BY_CLIENT: 'Devolução Pagamento por Desistência',
  PAYMENT_WAITING_RESUBMIT: 'Aguardando confirmação de reapresentação de pagamento',
  PENDENCY_BANK: 'Análise Banco',
  PENDENCY_MEU_TUDO: 'Pendência Meu TUDO',
  PENDING_AUTHORIZATION_SIGAC: 'Pendência Autorização Sigac',
  PENDING_CONSENT_SIGAC: 'Pendência Anuência Sigac',
  PORT_AUTO_TYPING_ERROR: 'Port erro na digitação automática',
  PORT_BANK_ANALYSIS: 'Port Análise Banco',
  PORT_CANCELED_BY_CLIENT: 'Port Cancelado pelo cliente',
  PORT_CANCEL_REQUESTED_BY_CLIENT: 'Port. Solicitação de cancelamento pelo cliente',
  PORT_CIP: 'CIP',
  PORT_CIP_INPROGRESS_PORTABILITY: 'CIP Contrato em Andamento',
  PORT_CIP_REJECTED: 'Port CIP Rejeitada',
  PORT_CLIENT_INELIGIBLE_FOR_LOAN: 'Port. Cliente não elegível',
  PORT_CONFERED_ONLINE_ENDORSEMENT: 'Port conferido averbação online',
  PORT_CONFERENCE: 'Port Conferência',
  PORT_CONFERENCE_ADDITIONAL_WORKCODE_VALIDATION: 'Port Conferência Adicional do Código de Trabalho',
  PORT_CONFERENCE_ON_HOLD: 'Port Conferência em espera',
  PORT_CONFERENCE_PENDENCY: 'Port Conferência da pendência resolvida',
  PORT_DISAPPROVED: 'Port Reprovado (não utilizar)',
  PORT_DIVERGENT_CONTRACT: 'CIP Contrato Divergente',
  PORT_DIVERGING_BALANCE: 'CIP Saldo Divergente',
  PORT_DIVERGING_INSTALLMENT: 'CIP Parcela Divergente',
  PORT_ENDORSED: 'Port Averbado',
  PORT_ENDORSEMENT: 'Port Averbação',
  PORT_ENDORSEMENT_PENDING: 'Port Pendência Averbação',
  PORT_ENDORSEMENT_PENDING_TECHNOLOGY_REVIEW: 'Port Pendente Revisão da Tecnologia',
  PORT_EXCEEDED_MARGIN_ANALISYS: 'Port Análise Margem Excedida',
  PORT_FORMALIZATION: 'Port Pendência Formalização',
  PORT_FORMALIZATION_DIVERGING_BALANCE: 'CIP Saldo Divergente (Formalização)',
  PORT_INTEGRATION_ERROR_FOR_RATE_MORE_THAN_ALLOWED: 'Port erro integração taxa maior que 1,80',
  PORT_LIQUIDATED: 'CIP Contrato Liquidado',
  PORT_LOST_OUTSTANDING_BALANCE: 'Port Saldo Devedor Perdido',
  PORT_MINIMAL_CONFERENCE: 'Port - Conferência minima',
  PORT_PAID: 'Portabilidade Pago',
  PORT_PAID_WAITING_REFIN: 'Port paga aguardando refin',
  PORT_PAYING_OUTSTADING_BALANCE: 'Port pagando saldo devedor',
  PORT_PAYING_OUTSTANDING_BALANCE: 'Port Pagamento Saldo devedor',
  PORT_PENDENCY: 'Port Pendência',
  PORT_PENDENCY_MEU_TUDO: 'Port Pendência Meu TUDO',
  PORT_PENDING_AUTHORIZATION_SIGAC: 'Port Pendência Autorização Sigac',
  PORT_PENDING_CONSENT_SIGAC: 'Port Pendência Anuência Sigac',
  PORT_PORTABILITY_SUCCESS: 'Portabilidade Sucesso',
  PORT_POSSIBILITY_FRAUD: 'Port possível fraude',
  PORT_PRODUCT_SECURITY: 'Port Segurança do Produto',
  PORT_PRODUCT_SECURITY_ON_HOLD: 'PORT - Segurança do produto em espera',
  PORT_RATE_MORE_THAN_ALLOWED: 'Port taxa maior do que 1,80',
  PORT_REFUSED_ADMISSION_TIME: 'Tempo de admissão insuficiente',
  PORT_REFUSED_CLIENT_PENDING_DOCUMENT: 'Port Reprovado Pendente Cliente (Documentação)',
  PORT_REFUSED_CLIENT_PENDING_FORMALIZATION: 'Port Reprovado Pendente Cliente (Formalização)',
  PORT_REFUSED_COMPLIANCE: 'Reprovado por Compliance',
  PORT_REFUSED_CONTRACT: 'Port Contrato reprovado (não utilizar)',
  PORT_REFUSED_DIFF_CONTRACT_NUMBER: 'Port Reprovado Número de Contrato Divergente',
  PORT_REFUSED_DIFF_INSTALLMENT: 'Port Reprovado parcela divergente',
  PORT_REFUSED_DIFF_OUTSTANDING_BALANCE: 'Port Reprovado Saldo Divergente',
  PORT_REFUSED_DIVERGENT_VALUES: 'Valor divergente',
  PORT_REFUSED_DOCUMENT_WITH_RESTRICTION: 'Port Reprovado CPF com Restrição',
  PORT_REFUSED_EMPLOYEE_FOUNDATION: 'Empresa recente',
  PORT_REFUSED_EMPLOYMENT_RELATIONSHIP_INELIGIBLE_FOR_LOAN: 'Vínculo empregatício não elegível para crédito',
  PORT_REFUSED_EMPLOYMENT_RELATIONSHIP_INVALID: 'Vínculo empregatício inválido',
  PORT_REFUSED_ENDORSEMENT_PENDING: 'Port Reprovado Averbação Pendente',
  PORT_REFUSED_FINISHED_CONTRACT: 'Port Reprovado Contrato Liquidado',
  PORT_REFUSED_FRAUD: 'Port Reprovado Fraude',
  PORT_REFUSED_FRUSTRATED_PORTABILITY: 'Port Reprovado Portabilidade Frustrada',
  PORT_REFUSED_INPROGRESS_PORTABILITY: 'Port Reprovado Contrato em Andamento',
  PORT_REFUSED_INTERNAL_POLICY: 'Port Reprovado Política Interna',
  PORT_REFUSED_LIQUIDATED_CONTRACT: 'Port Reprovado Contrato Liquidado',
  PORT_REFUSED_MAX_RISK: 'Port Reprovado Risco Máximo Atingido',
  PORT_REFUSED_MINIMUN_WAGE: 'Salário abaixo do permitido',
  PORT_REFUSED_NOT_LITERATE: 'Port Reprovado Não Alfabetizado',
  PORT_REFUSED_NOT_PROFITABLE: 'Port Reprovado Não Rentável',
  PORT_REFUSED_ONBOARDING_PF: 'Reprovado no Onboarding PF',
  PORT_REFUSED_ONBOARDING_PJ: 'Reprovado no Onboarding PJ',
  PORT_REFUSED_PROPOSAL_EXPIRED: 'Proposta expirada',
  PORT_REFUSED_PROPOSAL_INVALID: 'Proposta inválida',
  PORT_REFUSED_RESTRICTED_CNAE: 'CNAE não aceito',
  PORT_REFUSED_RETENTION: 'Port Reprovado Retenção',
  PORT_REFUSED_SCR: 'Reprovado com base no SCR',
  PORT_REFUSED_VALUE_UNDER_MIN: 'Port Reprovado Valor inferior ao permitido',
  PORT_REFUSED_VISUALLY_IMPAIRED: 'Port - Reprovado Deficiente Visual',
  PORT_REFUSED_WORKCODE_NOT_ACCEPTED: 'Ocupação não elegível',
  PORT_RETENTION: 'CIP Retenção',
  PORT_RETENTION_ANALYSIS: 'Port Análise de Retenção',
  PORT_RETYPING: 'Redigitação',
  PORT_RETYPING_DIVERGENT_CONTRACT: 'Redigitação Contrato Divergente',
  PORT_RETYPING_DIVERGING_BALANCE: 'Redigitação saldo divergente',
  PORT_RETYPING_FORMALIZATION: 'Redigitação Formalização',
  PORT_RETYPING_RETENTION: 'Redigitação Retenção',
  PORT_TYPING: 'Port Digitação',
  PORT_TYPING_PENDENCY: 'Port Digitação Pendência',
  PORT_UNDEFINED: 'Port Não definido',
  PORT_USED_OVER_35_PERCENT: 'Port 35% da Margem',
  PORT_USED_OVER_35_PERCENT_CONFERED: 'Port 35% da Margem Conferido',
  PORT_WAITING_SCR_REVIEW: 'Aguardando análise SCR',
  PORT_WAITING_SCR_VALIDATION: 'Aguardando validação SCR',
  PORT_WAITING_WORKER_DATA: 'Aguardando dados do trabalhador',
  PORT_WORKER_DATA_ERROR: 'Dados do trabalhador inválidos',
  PORT_WORKER_REGISTRATION_ERROR: 'Erro no cadastro do trabalhador',
  POSSIBILITY_FRAUD: 'Possibilidade de Fraude',
  PRODUCT_SECURITY: 'Segurança do Produto',
  PRODUCT_SECURITY_ON_HOLD: 'Segurança do produto em espera',
  REFIN_CCB_NUMBER_NOT_FOUND: 'Saldo devedor não encontrado',
  REFIN_CONFERENCE_ON_HOLD: 'Conferência em espera',
  REFIN_CONTRACT_VALIDATION: 'Validação do Contrato',
  REFIN_DIVERGING_BALANCE: 'Saldo Divergente',
  REFIN_NEGATIVE_OUTSTANDING_BALANCE: 'Reprovado - Troco Negativo',
  REFIN_OUTDATED_OUTSTANDING_BALANCE: 'Saldo devedor expirado',
  REFIN_OUTSTADING_BALANCE_PAID: 'Saldo Devedor Pago',
  REFIN_PAYING_OUTSTADING_BALANCE: 'Refin. Pagando Saldo Devedor',
  REFIN_PAYING_VALUE_FOR_DEPOSIT: 'Pagamento Enviado',
  REFIN_PRODUCT_SECURITY_ON_HOLD: 'Segurança do Produto em espera',
  REFIN_REFUSED_DIFF_OUTSTANDING_BALANCE: 'Reprovado - Troco Divergente',
  REFIN_REFUSED_LIQUIDATED_CONTRACT: 'Reprovado - Contrato Liquidado',
  REFIN_WAITING_UNLOCK_BENEFIT_DATE: 'Aguardando data de desbloqueio',
  REFUSED_ADMISSION_TIME: 'Reprovado - Tempo de Adimissão',
  REFUSED_AUTOMATIC: 'Reprovado Automático',
  REFUSED_BANK_ANALISYS: 'Reprovado - Análise Banco',
  REFUSED_CLIENT_PENDING_DOCUMENT: 'Reprovado - Pendente Cliente (Documentação)',
  REFUSED_CLIENT_PENDING_FORMALIZATION: 'Reprovado - Pendente Cliente (Formalização)',
  REFUSED_COMPLIANCE: 'Reprovado - Compliance',
  REFUSED_CONTRACT: 'Reprovado 2 (não utilizar)',
  REFUSED_DIVERGENT_VALUES: 'Reprovado - Valores Divergentes',
  REFUSED_DOCUMENT_WITH_RESTRICTION: 'Reprovado - CPF com Restrição',
  REFUSED_EMPLOYEE_FOUNDATION: 'Reprovado - Tempo de Fundação da Empresa',
  REFUSED_EMPLOYMENT_RELATIONSHIP_INELIGIBLE_FOR_LOAN: 'Reprovado - Vinculo Empregaticio Inelegivel para Emprestimo',
  REFUSED_EMPLOYMENT_RELATIONSHIP_INVALID: 'Reprovado - Vinculo Empregaticio Invalido',
  REFUSED_ENDORSEMENT_FAIL: 'Reprovado - Averbação Falhou',
  REFUSED_ENDORSEMENT_PENDING: 'Reprovado - Averbação Pendente',
  REFUSED_EXCEEDED_MARGIN: 'Reprovado - Margem Excedida',
  REFUSED_FRAUD: 'Reprovado Fraude',
  REFUSED_INPROGRESS_PORTABILITY: 'Reprovado Portabilidade em Andamento',
  REFUSED_INSTALLMENTS_GREATER_THAN_BENEFIT_ENDED_DATE: 'Reprovado - Prazo maior que a extinção do benefício',
  REFUSED_INTERNAL_POLICY: 'Reprovado - Política Interna',
  REFUSED_MAXIMUM_MARGIN_PERCENTAGE: 'Reprovado - Margem Máxima',
  REFUSED_MAXIMUM_NUMBER_OF_CONTRACTS_REACHED: 'Reprovado - Número Máximo de Contratos Atingido',
  REFUSED_MAX_RISK: 'Reprovado - Risco Máximo Atingido',
  REFUSED_MINIMUN_WAGE: 'Reprovado - Salário informado é menor que o salário mínimo permitido.',
  REFUSED_NOT_LITERATE: 'Reprovado - Não Alfabetizado',
  REFUSED_ONBOARDING_PF: 'Reprovado - Onboarding BTG',
  REFUSED_ONBOARDING_PJ: 'Reprovado - Onboarding PJ',
  REFUSED_PAB_OPERATIONAL_ISSUE: 'REFUSED_PAB_OPERATIONAL_ISSUE',
  REFUSED_PAYMENT_NOT_MADE: 'Recusado Pagamento não realizado',
  REFUSED_PEP: 'Reprovado - PEP',
  REFUSED_PROPOSAL_EXPIRED: 'Reprovado - Proposta Expirada',
  REFUSED_PROPOSAL_INVALID: 'Reprovado - Proposta Invalida',
  REFUSED_REFIN_NO_TRANSFER_RECORDED: 'Sem repasse registrado',
  REFUSED_REFIN_OVERDUE_INSTALLMENTS: 'Reprovado - Parcelas em atraso',
  REFUSED_REFIN_TRANSFER_TYPE_INEGIBLE: 'Tipo de Repasse Inelegível',
  REFUSED_RESTRICTED_CNAE: 'Reprovado - CNAE restrito',
  REFUSED_SCR: 'Reprovad - SCR',
  REFUSED_UNABLE_UNLOCK_BENEFIT: 'Reprovado por Bloqueio do Benefício',
  REFUSED_VISUALLY_IMPAIRED: 'Reprovado - Deficiente Visual',
  REFUSED_WORKCODE_NOT_ACCEPTED: 'Reprovado - Codigo de trabalho não aceito',
  REF_PORT_ATTEMPTING_ENDORSEMENT: 'Refin Port Tentativa Averbação',
  REF_PORT_ENDORSED: 'Refin Port Averbado',
  REF_PORT_ENDORSEMENT: 'Refin Port Averbação',
  REF_PORT_ENDORSEMENT_PENDING: 'Refin Port Pendência Averbação',
  REF_PORT_FORMALIZATION: 'Refin Port Pendência Formalização',
  REF_PORT_HALF_ENDORSED: 'Refin Port Parcialmente Averbada',
  REF_PORT_HALF_PAID: 'Refin Port Parcialmente Paga',
  REF_PORT_PAID: 'Refin Port Pago',
  REF_PORT_PAID_DIVERGENT_VALUE: 'Refin Port Pago Saldo Divergente',
  REF_PORT_PAYMENT_RESUBMITTED: 'Refin Port Pagamento Reapresentado',
  REF_PORT_PAYMENT_RETURNED: 'Refin Port Pagamento Devolvido',
  REF_PORT_PAYMENT_RETURNING_BY_CLIENT: 'Refin Port Devolução Pagamento por Desistência',
  REF_PORT_PENDENCY: 'Refin Port Pendência',
  REF_PORT_UNDONE_ENDORSEMENT: 'Refin Port Desaverbado',
  REF_PORT_UNDO_ENDORSEMENT: 'Refin Port Desaverbação',
  REF_PORT_WAITING_UNLOCK_BENEFIT_DATE: 'Refin Port Aguardando Desbloqueio do Benefício',
  SALARY_INCREASE: 'Aumento salarial',
  SALARY_INCREASE_CONFERED: 'Aumento salarial conferido',
  SALARY_INCREASE_ENDORSEMENT: 'Averbação aumento salarial',
  SALARY_INCREASE_MAGNETIC_CARD: 'SALARY_INCREASE_MAGNETIC_CARD',
  SALARY_INCREASE_MINIMAL_CONFERENCE: 'SALARY_INCREASE_MINIMAL_CONFERENCE',
  SCR_VALIDATION_ERROR: 'Erro - Validação SCR',
  TYPING: 'Digitação',
  UNDEFINED: 'Não definido',
  UNDONE_ENDORSEMENT: 'Desaverbado',
  UNDONE_ENDORSEMENT_PAYMENT_NOT_MADE: 'Desaverbado - Pagamento não realizado',
  UNDO_ENDORSEMENT: 'Desaverbação',
  UNDO_ENDORSEMENT_PAYMENT_NOT_MADE: 'Desaverbação - Pagamento não realizado',
  UNICO_CONFERENCE: 'Conferência - Único',
  UNICO_SALARY_INCREASE_CONFERENCE: 'Conferência aumento salarial',
  UNICO_USED_OVER_35_PERCENT_CONFERENCE: 'UNICO_USED_OVER_35_PERCENT_CONFERENCE',
  USED_35_PERCENT_ENDORSEMENT: 'Averbação Margem de 35%',
  USED_OVER_35_PERCENT: '35% da Margem',
  USED_OVER_35_PERCENT_CONFERED: '35% da Margem Conferido',
  VALIDATE_AUTOMATIC_CONFERENCE: 'Validação Conferência Automática',
  VALIDATE_PAB_AUTOMATIC_CONFERENCE: 'VALIDATE_PAB_AUTOMATIC_CONFERENCE',
  VALIDATION_MAXIMUM_MARGIN_PERCENTAGE: 'Validação Margem Máxima Atingida',
  WAITING_ELIGIBILITY_REVIEW: 'Aguardando Revisão Elegibilidade',
  WAITING_ONBOARDING_PF: 'Aguardando Onboarding PF',
  WAITING_ONBOARDING_PJ: 'Aguardando Onboarding PJ',
  WAITING_REFUSE_ONBOARDING_PF: 'Aguardando Revisão - Onboarding PF',
  WAITING_REFUSE_ONBOARDING_PJ: 'Aguardando Revisão - Onboarding PJ',
  WAITING_SCR_REVIEW: 'Aguardando Revisão - SCR',
  WAITING_SCR_VALIDATION: 'Aguardando Validação SCR',
  WAITING_TO_SEND_TO_BANK: 'Aguardando envio à Consignatária',
  WAITING_UNDO_ENDORSEMENT: 'Aguardando Desaverbação',
  WAITING_UNLOCK_BENEFIT_DATE: 'Aguardando Desbloqueio do Benefício',
  WAITING_WORKER_DATA: 'Aguardando Dados do Trabalhador',
  WORKER_DATA_ERROR: 'Erro - Dados do Trabalhador',
  WORKER_REGISTRATION_ERROR: 'Erro - Matrícula do Trabalhador',
  REQUEST_FOR_DISCHARGE_SETTLEMENT: 'Solicitação de Quitação do saque',
  SETTLED_WITHDRAWAL: 'Saque Quitado',
};

export const CONFERENCE_BY_PERSON_OPERATION_STEPS = [
  'PORT_CONFERENCE',
  'VALIDATE_AUTOMATIC_PORT_CONFERENCE',
  'PORT_CONFERENCE_ADDITIONAL_WORKCODE_VALIDATION',
  'PORT_CONFERENCE_PENDENCY',
  'PORT_TYPING',
  'PORT_PRODUCT_SECURITY',
  'PORT_PENDENCY_MEU_TUDO',
  'PORT_PRODUCT_SECURITY_ON_HOLD',
];

function OperationStepType(step: any) {
  return OPERATION_STEPS_TYPES[step] || step || null;
}

export default OperationStepType;
